<div>
    <div class="absolute inset-0 bg-primary"></div>

    <div class="relative flex min-h-screen items-center justify-center px-6 py-10 dark:bg-[#060818] sm:px-16">
        <div
            class="relative w-full max-w-[870px] rounded-md bg-[linear-gradient(45deg,#fff9f9_0%,rgba(255,255,255,0)_25%,rgba(255,255,255,0)_75%,_#fff9f9_100%)] p-2 dark:bg-[linear-gradient(52.22deg,#0E1726_0%,rgba(14,23,38,0)_18.66%,rgba(14,23,38,0)_51.04%,rgba(14,23,38,0)_80.07%,#0E1726_100%)]"
        >
            <div class="relative flex flex-col justify-center rounded-md bg-white/60 px-6 py-20 backdrop-blur-lg dark:bg-black/50 lg:min-h-[758px]">
                <div class="mx-auto w-full max-w-[440px]">
                    <div class="mb-7">
                        <h1 class="mb-3 text-2xl font-bold !leading-snug dark:text-white">Nova Senha</h1>
                        <p>Digite sua senha</p>
                    </div>
                    <form [formGroup]="resetPassForm" (ngSubmit)="submit()" class="space-y-5">
                        <div>
                            <label for="password" class="dark:text-white">Senha</label>
                            <div class="relative text-white-dark">
                                <input
                                    id="password"
                                    [type]="isPasswordVisible ? 'text' : 'password'"
                                    formControlName="newPassword"
                                    placeholder="Digite a nova senha"
                                    class="form-input ps-10 placeholder:text-white-dark"
                                />

                                <span (click)="togglePasswordVisibility()" class="om-h absolute start-4 top-1/2 -translate-y-1/2">
                                    <i [class]="isPasswordVisible ? 'fa fa-solid fa-unlock fs-1' : 'fa fa-solid fa-lock fs-1'"></i>
                                </span>
                            </div>
                            <div
                                class="invalid-feedback"
                                *ngIf="f['newPassword'].errors?.['required']  &&
                                        (resetPassForm.get('newPassword')?.dirty || resetPassForm.get('newPassword')?.touched)
                                    "
                            >
                                <div *ngIf="f['newPassword']?.errors">Senha Obrigatória</div>
                            </div>
                        </div>
                        <div>
                            <label for="Email" class="dark:text-white">Confirmar Senha</label>
                            <div class="relative text-white-dark">
                                <input
                                    id="mathPassword"
                                    [type]="isPasswordVisible ? 'text' : 'password'"
                                    formControlName="mathPassword"
                                    placeholder="Confirmar senha"
                                    class="form-input ps-10 placeholder:text-white-dark"
                                />
                                <span (click)="togglePasswordVisibility()" class="om-h absolute start-4 top-1/2 -translate-y-1/2">
                                    <i [class]="isPasswordVisible ? 'fa fa-solid fa-unlock fs-1' : 'fa fa-solid fa-lock fs-1'"></i>
                                </span>
                            </div>
                            <div
                                class="invalid-feedback"
                                *ngIf="f['mathPassword'].errors?.['required']  &&
                                        (resetPassForm.get('mathPassword')?.dirty || resetPassForm.get('mathPassword')?.touched)
                                    "
                            >
                                <div *ngIf="f['mathPassword']?.errors">Senha Obrigatória</div>
                            </div>
                            <div class="invalid-feedback" *ngIf="f['mathPassword'].errors?.['customError'] ">
                                {{ f['mathPassword'].errors?.['customError'] }}
                            </div>
                        </div>
                        <button
                            [disabled]="resetPassForm.invalid"
                            type="submit"
                            class="btn btn-gradient !mt-6 w-full border-0 uppercase shadow-[0_10px_20px_-10px_rgba(67,97,238,0.44)]"
                        >
                            CONFIRMAR
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
